<template>
  <el-select
    ref='selectCitys'
    class='selectCitys'
    v-model="value"
    value-key="id"
    multiple
    placeholder="选择城市"
    @change="change"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in cityList"
      :key="item.name"
      :label="item.name"
      :value="String(item.id)">
    </el-option>
  </el-select>
</template>
<script>
import {mapState} from 'vuex'

export default {
  name: 'SelectCitys',
  computed: {
    ...mapState('selectAddress', [
      'cityList'
    ])
  },
  data () {
    return {
      value: []
    }
  },
  props: ['callback', 'defaultCitys'],
  mounted () {
    this.value = this.defaultCitys || []
    // console.log('selectCitys', this.$refs.selectCitys.$refs)
  },
  watch: {
    value: function (params) {
      this.change(params)
    }
  },
  methods: {
    change (v) {
      this.$nextTick(() => {
        let tagHeight = this.$refs.selectCitys.$refs.tags.clientHeight
        // console.log('vvvv', v, tagHeight)
        if (v.length === 0) {
          this.$el.offsetParent.style.height = '50px'
        } else {
          this.$el.offsetParent.style.height = (tagHeight + 50) + 'px'
        }
        this.callback(v)
      })
    }

  }
}

</script>
<style lang='stylus'>

  .selectCitys .el-select__tags {
    max-width: 500px !important;
    width: 500px;
    top: 100%;
    transform: translateY(0);
    margin-top: 10px;
  }
  .selectCitys.el-select .el-input.is-focus .el-input__inner,
  .selectCitys.el-select .el-input .el-input__inner {
    max-height: 40px;
    height:40px !important;
  }
  .selectCitys.el-select .el-tag {
    margin: 2px 6px 2px 0;
  }
  .selectCitys .el-tag--small{
    height: 36px;
    padding: 0 8px;
    line-height: 36px;
  }
  .selectCitys .el-input .el-input__inner {
    width: 100%;
  }
</style>
